<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.recordSearch.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div class="handle-headright">
                <!-- <el-date-picker
                    v-model="query.startDate"
                    type="date"
                    placeholder="开始日期"
                    class="handle-select mr10"
                    :picker-options="pickerOptions0"
                >
                </el-date-picker>
                <el-date-picker
                    v-model="query.endDate"
                    type="date"
                    placeholder="结束日期"
                    class="handle-select mr10"
                    :picker-options="pickerOptions0"
                >
                </el-date-picker>-->

                <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="$t('pages.recordSearch.rangeSeparator')" :start-placeholder="$t('pages.recordSearch.startDate')" :end-placeholder="$t('pages.recordSearch.endDate')" :picker-options="pickerOptions" class="handle-select mr10" style="width: 300px"></el-date-picker>

                <el-select v-model="query.LogType" :placeholder="$t('pages.recordSearch.logType')" class="handle-select mr10">
                    <!-- <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"> </el-option> -->
                    <el-option key :label="$t('pages.recordSearch.all')" value></el-option>
                    <el-option key="0" :label="$t('pages.recordSearch.login')" value="0"></el-option>
                    <el-option key="1" :label="$t('pages.recordSearch.visit')" value="1"></el-option>
                    <el-option key="2" :label="$t('pages.recordSearch.operate')" value="2"></el-option>
                    <el-option key="3" :label="$t('pages.recordSearch.exception')" value="3"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.recordSearch.search')}}</el-button>
            </div>

            <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" :height="tableHeight">
                <el-table-column type="index" width="50" :label="$t('pages.recordSearch.index')"></el-table-column>
                <el-table-column sortable prop="operateTime" :label="$t('pages.recordSearch.operateTime')" width="160">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        {{ scope.row.operateTime | formateData }}
                    </template>
                </el-table-column>
                <el-table-column prop="operateUser" width="100" :label="$t('pages.recordSearch.operator')"></el-table-column>
                <el-table-column prop="logType" :label="$t('pages.recordSearch.recordType')" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="logTypeColor(scope.row.logType)" disable-transitions>{{ scope.row.logType | LogTypeFormat }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="moduleName" :label="$t('pages.recordSearch.module')"></el-table-column>
                <el-table-column prop="source" :label="$t('pages.recordSearch.source')"></el-table-column>
                <!-- <el-table-column prop="content" label="内容" width="500">
                    <template slot-scope="scope">{{ scope.row.content | ContentFormat }}</template>
                </el-table-column>-->
                <el-table-column prop="content" :label="$t('pages.recordSearch.content')" width="520">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top-start" :title="$t('pages.recordSearch.detail')" width="450">
                            <p>{{ scope.row.content }}</p>
                            <div slot="reference" class="name-wrapper">{{ scope.row.content | ContentFormat }}</div>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { dateFormat, SortField } from '../../utils/helper';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [
                    {
                        text: this.$t('pages.recordSearch.shortcuts.lastWeek'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: this.$t('pages.recordSearch.shortcuts.lastMonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: this.$t('pages.recordSearch.shortcuts.lastThreeMonths'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            tableHeight: window.innerHeight * 0.75,
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                LogType: ''
            }
        };
    },
    filters: {
        LogTypeFormat(Type) {
            var Name = '';
            if (Type == '0') {
                Name = '登录';
            } else if (Type == '1') {
                Name = '访问';
            } else if (Type == '2') {
                Name = '操作';
            } else if (Type == '3') {
                Name = '异常';
            } else {
                Name = '其它';
            }
            return Name;
        },
        ContentFormat(content) {
            if (content.length >= 50) {
                content = content.substr(0, 60) + '...';
            }
            return content;
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.query.daterange = [start, end];
        this.getBalance();
    },
    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning(this.$t('pages.recordSearch.dateRequired'));
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));

            this.$zybhttp
                .get('DataInquiry/RecordSearch', {
                    params: {
                        startDate: this.query.startDate,
                        endDate: this.query.endDate,
                        LogType: this.query.LogType
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        this.logRecords = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.recordSearch.fetchError')));
        },
        logTypeColor(Type) {
            var Name = '';
            if (Type == '0') {
                Name = 'success';
            } else if (Type == '1') {
                Name = 'warning';
            } else if (Type == '2') {
                Name = 'info';
            } else if (Type == '3') {
                Name = 'danger';
            } else {
                Name = 'brand';
            }
            return Name;
        },
        getBalance() {
            var serach = {};
            this.$zybhttp
                .post('Balance/GetList', { Field3: '1', Field4: '1' })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = d.sort(SortField('id', 'asc'));
                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.recordSearch.fetchError')));
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
